import { withFinalField } from '@beef/form';
import { NAutoSearchInput, NAutoSuggestInput, NInput } from "./components";
export var FFAutoSuggestInput = withFinalField(NAutoSuggestInput);
export var FFInput = withFinalField(NInput);
export var FFAutoSearchInput = withFinalField(NAutoSearchInput);